import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { HIDE_WELCOME_SCREEN } from './types';
import { uiLoaded } from './index';

const hideWelcomeScreenActionPayloadSchema = Joi.any().optional();

const hideWelcomeScreenAction = actionCreator(
  HIDE_WELCOME_SCREEN,
  hideWelcomeScreenActionPayloadSchema,
);

export const layoutHideWelcomeScreenThunkAction =
  // eslint-disable-next-line no-unused-vars
  () => (dispatch, getState) => {
    dispatch(hideWelcomeScreenAction());
    dispatch(uiLoaded());
  };
